import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { EASE, Eyebrow, FadeUp, MaskLines } from "./Motion";
import { MAIN } from "../../lib/catalog";
import { FestiveTile } from "./FestiveTile";

const reveal = { hidden: { clipPath: "inset(100% 0 0 0)" }, show: { clipPath: "inset(0% 0 0 0)", transition: { duration: 1.2, ease: EASE } } };

const Tile = ({ c, i, big, wide }) => {
  const spot = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--x", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--y", `${e.clientY - r.top}px`);
  };
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.15 }}
      transition={{ delayChildren: (i % 4) * 0.08 }}
      className={big ? "md:col-span-2 md:row-span-2" : wide ? "md:col-span-2" : ""}
    >
      <Link to={`/c/${c.slug}`} onMouseMove={spot} data-testid={`collection-tile-${c.slug}`} className="group relative block h-full overflow-hidden rounded-[26px] bg-[#240620]">
        <motion.div variants={reveal} className="absolute inset-0">
          <img src={c.cover} alt={c.name} loading="lazy" style={{ objectPosition: c.pos || "50% 50%" }} className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-110" />
        </motion.div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#190317] via-[#190317]/35 to-transparent" />
        <div className="spotlight absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
        <span className="absolute right-4 top-4 flex h-11 w-11 items-center justify-center rounded-full bg-[#FFF8EF]/10 text-[#FFF8EF] backdrop-blur-md transition-[transform,background-color] duration-500 group-hover:rotate-45 group-hover:bg-[#D4AF37] group-hover:text-[#240620]">
          <ArrowUpRight size={20} />
        </span>
        <div className="absolute inset-x-0 bottom-0 p-5 sm:p-6">
          <h3 className={`font-display leading-none text-[#FFF8EF] ${big ? "text-4xl sm:text-6xl" : "text-3xl"}`}>{c.name}</h3>
          <p className={`mt-2 text-sm text-[#E8D8C8] ${big ? "max-w-md sm:text-base" : ""}`}>{c.desc}</p>
          {big && <p className="mt-4 font-cinzel text-[11px] tracking-[0.3em] text-[#D4AF37]">Our signature →</p>}
        </div>
      </Link>
    </motion.div>
  );
};

export const Collections = () => (
  <section id="collections" className="relative bg-[#FFF8EF] py-14 text-[#240620] sm:py-20" data-testid="collections-section">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8">
      <div className="mb-8 grid gap-6 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <Eyebrow className="!text-[#A0216B]">The collection · seven signatures</Eyebrow>
          <h2 className="mt-4 font-display text-5xl font-medium leading-[0.95] sm:text-6xl lg:text-7xl">
            <MaskLines lines={["Flowers, shaped", <span key="i" className="italic text-[#A0216B]">for every ritual.</span>]} />
          </h2>
        </div>
        <FadeUp className="lg:col-span-5">
          <p className="text-base leading-relaxed text-[#4a2443] sm:text-lg">
            From a single string of tied jasmine to a full mandap — every piece is strung by hand on the day, packed for freshness and
            delivered on time.
          </p>
        </FadeUp>
      </div>
      <FestiveTile />
      <div className="grid auto-rows-[300px] grid-cols-1 gap-4 md:grid-cols-2 lg:auto-rows-[280px] lg:grid-cols-4 lg:gap-5">
        {MAIN.map((c, i, arr) => <Tile key={c.slug} c={c} i={i} big={i === 0} wide={i >= arr.length - 2} />)}
      </div>
    </div>
  </section>
);
